<div>
    @if (linkedRisks) {
        <table class="table fixed-header table-sm">
            <thead>
                <tr>
                    <th style="width: 120px">{{ 'controls.effLinkedRisks.riskIdentifier' | transloco }}</th>
                    <th>{{ 'controls.effLinkedRisks.name' | transloco }}</th>
                    <th class="d-none d-lg-table-cell">{{ 'controls.effLinkedRisks.description' | transloco }}</th>
                    <th style="width: 30px"></th>
                </tr>
            </thead>
            <tbody>
                @for (linkedRisk of linkedRisks; track linkedRisk) {
                    <tr (click)="onRiskClick(linkedRisk)" class="action-button">
                        <td [title]="linkedRisk.identifier">{{ linkedRisk.identifier }}</td>
                        <td [title]="linkedRisk.name">{{ linkedRisk.name }}</td>
                        <td [title]="linkedRisk.description" class="d-none d-lg-table-cell">
                            {{ linkedRisk.description }}
                        </td>
                        <td>
                            <div [title]="'controls.effLinkedRisks.openRisk' | transloco">
                                <i class="fas fa-external-link-alt"></i>
                            </div>
                        </td>
                    </tr>
                }
                @if (!linkedRisks.length) {
                    <tr>
                        <td colspan="4" align="center">{{ 'controls.effLinkedRisks.noRisks' | transloco }}</td>
                    </tr>
                }
            </tbody>
        </table>
    } @else {
        <div>
            <div class="fancy-loader"></div>
        </div>
    }
</div>
